<template>
  <div class="about">
    <h1>7</h1>
  </div>
</template>


<script>
export default {
  data(){
    return {
      
    }
  },
  methods:{

  }
}
</script>